import { render } from "./FlashCardsV2.vue?vue&type=template&id=4e1acdb3&scoped=true"
import script from "./FlashCardsV2.vue?vue&type=script&lang=js"
export * from "./FlashCardsV2.vue?vue&type=script&lang=js"

import "./FlashCardsV2.vue?vue&type=style&index=0&id=4e1acdb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1acdb3"]])

export default __exports__